export default [
  {
    name: 'API Calls Date Report',
    path: '/api-calls/report',
    component: () => import('./pages/ApiCallsDateReport.vue'),
    meta: {
      ability: [
        {
          resource: 'api-calls-report/date-report/:type',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Api Calls Search',
    path: '/api-calls/search',
    component: () => import('@/modules/apiCalls/pages/ApiCallSearch.vue'),
    meta: {
      ability: [
        {
          resource: 'api-calls/:id',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Api Calls List',
    path: '/api-calls/list',
    component: () => import('@/modules/apiCalls/pages/ApiCalls'),
    meta: {
      ability: [
        {
          resource: 'api-calls',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'View Api Call',
    path: '/api-calls/view/:id',
    component: () => import('@/modules/apiCalls/pages/ApiCallDetailsPage.vue'),
    meta: {
      ability: [
        {
          resource: 'api-calls/:id',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'API Calls Grouped Report',
    path: '/api-calls/grouped-report',
    component: () => import('./pages/ApiCallsGroupedReport.vue'),
    meta: {
      ability: [
        {
          resource: 'api-calls-report/grouped/:type',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'API Calls Realtime Report',
    path: '/api-calls/realtime-report',
    component: () => import('../reports/realtime/pages/Realtime.vue'),
    props:{
      api: 'api-calls/group-date-product-report',
    },
    meta: {
      ability: [
        {
          resource: 'api-calls/group-date-product-report',
          actions: ['read'],
        },
      ],
    },
  },
]
